// extracted by mini-css-extract-plugin
export default {"integer":"Price_integer__w4hun","coma":"Price_coma__dnAyP","suffix":"Price_suffix__aXvGR"};